import React from "react";
import { Calorie } from "./calorie";
import { SoftValidationProvider } from "../../../../../contexts/soft-validation/soft-validation-provider";
import classnames from "classnames";

const CalorieInfo = (props) => {
    const classNames = classnames("calories", {
        "horizontal-scroll": props.enableHorizontalScroller,
    });

    return (
        <div className={classNames}>
            <h3>Calories</h3>
            <div className="row">
                {props.data.map((calorieInfo, index) => {
                    const { dataQualityIssue } = calorieInfo;
                    const hasWarning = !!dataQualityIssue;

                    return (
                        <SoftValidationProvider
                            key={`fact_item_fields_${props.section}_${index}`}
                            enableWarning
                            hasWarning={hasWarning}
                            tooltip={hasWarning ? dataQualityIssue.message : undefined}
                        >
                            <Calorie
                                updateField={props.updateField}
                                calorieInfo={calorieInfo}
                                index={index}
                            />
                        </SoftValidationProvider>
                    );
                })}
            </div>
        </div>
    );
};

export default CalorieInfo;
